import Timelapse from "./Timelapse";
export default Timelapse;